export default __webpack_public_path__ + "f2b618987ecbaf47bebc5a3b3fca0821.svg";